import { useEffect, useState } from 'react'

// import pinchtozoom from '../../../assets/images/pinchtozoom.png'
import logoNacer from '../../../assets/images/logo-nacer.webp'
import biatLogo from '../../../assets/images/biatLogo.png'
import biatFeaturing from '../../../assets/images/featuringBiat.PNG'
import getStartedImage from '../../../assets/images/getStartedImage.gif'
import Footer from '../../Footer/Footer'
import { BiArrowBack } from 'react-icons/bi'

const Biat = () => {
  const [loading, setLoading] = useState(true)
  // const [showPopupTayaraProject, setShowTayaraProjectPopup] = useState(true)

  useEffect(() => {
    import('./projects.css')
      .then(() => setLoading(false)) // CSS is imported, stop loading
      .catch(() => setLoading(false)) // In case of error, stop loading as well
  }, [])

  return (
    <div>
      {/* {showPopupTayaraProject && (
        <div
          class="showpopup"
          onClick={(e) => {
            if (e.target !== e.currentTarget) return
            handleCloseOnboardingTayaraProject()
          }}
        >
          <img
            src={pinchtozoom}
            alt="pinch to zoom project images"
            className="NavigationGuide"
          />
          <button onClick={() => handleCloseOnboardingTayaraProject()}>
            Skip
          </button>
        </div>
      )} */}
      {loading ? (
        <div class="spinner-wrap-on-loading">
          <div className="loading-container">
            <img className="logo-on-loading" src={logoNacer} alt="" />
            <div class="spinner-item"></div>
            <div class="spinner-item spinner-item--2"></div>
          </div>
        </div>
      ) : (
        <>
          <div className="bg-black font-sans overflow-hidden">
            <header class="header">
              <a href="https://nacermediouni.vercel.app/">
                <img class="logo" src={logoNacer} alt="" />
              </a>
            </header>
            <div className="absolute flex flex-col z-[9999] top-11 right-6 md:right-12 w-fit h-fit">
              <a
                className=" flex gap-4 items-center text-sm font-bold  text-white hover:text-neutral-500 "
                href="https://nacer-mediouni.netlify.app/works"
              >
                <BiArrowBack size={20} />
                Back to projects
              </a>
              <span className="relative left-10 bottom-3 rotate-90 w-[1px] h-10 bg-[#00ffc6]"></span>
            </div>
            <div className="w-full h-screen bg-[url('/src/assets/images/featuringBiat.PNG')] bg-no-repeat bg-cover lg:bg-cover lg:bg-fixed  bg-center ">
              <div className="absolute inset-0 z-10 w-full h-screen bg-black/80 ">
                <div className="w-full h-full flex flex-col items-center justify-center gap-6">
                  {/* <h1 className="text-6xl font-extrabold">Tayara</h1> */}
                  <img
                    src={biatLogo}
                    alt="tayara-project-logo"
                    className="w-[80%] md:w-[35%]"
                  />

                  <p className="mx-4 lg:mx-[15%] text-base lg:text-xl text-center font-medium">
                    An Online Appointment Scheduling Platform: a digital
                    solution designed to simplify the process of booking
                    appointments with bank representatives.
                  </p>
                  <div className="w-full absolute bottom-10">
                    <div class="scd">
                      <div class="chv"></div>
                      <div class="chv"></div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="w-full h-full py-10 px-[10%] md:px-[20%] bg-slate-50 text-black ">
              <div className="w-full flex flex-col gap-4">
                <div className="flex flex-col gap-2 text-neutral-600">
                  <h1 className="text-xl font-extrabold">Role</h1>
                  <span className="text-base">UX/UI Designer</span>
                </div>
                <div className="flex flex-col gap-2 text-neutral-600">
                  <h1 className="text-xl font-extrabold">Settings</h1>
                  <span className="text-base">
                    Freelance project with Liberrex and BIAT Bank Tunisia
                  </span>
                </div>
                <div className="flex flex-col gap-2 text-neutral-600">
                  <h1 className="text-xl font-extrabold">Timeline</h1>
                  <span className="text-base">1 month</span>
                </div>
              </div>
            </div>

            <div className="w-full h-full pt-10 pb-1 px-[10%] md:px-[20%] bg-white text-neutral-600 ">
              <div className="w-full flex justify-between items-center flex-wrap gap-4">
                <div className="w-fit my-4">
                  <h1 className="text-2xl md:text-3xl font-extrabold">
                    Redesigning BIAT Bank's MonRDV SaaS
                  </h1>
                  {/* <h1 className="text-base md:text-xl font-extrabold my-2">
                    #1 Most visited Tunisian Classified Marketplace
                  </h1> */}
                </div>
                <a
                  href="https://rdv.biat.com.tn/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className=" p-4 text-sm lg:text-base text-white font-medium bg-neutral-800 hover:bg-transparent hover:text-neutral-800 border-2 border-neutral-800"
                >
                  View final product
                </a>
              </div>
              <img
                src={biatFeaturing}
                className="w-full my-10 rounded-3xl border-[1px] border-neutral-100"
                alt="Biat project"
              />
              <p className="text-base md:text-lg  font-normal font-sans my-10">
                <b>BIAT Bank's existing appointment scheduling SaaS </b> was not
                meeting the needs of its growing customer base. It had a high
                abandonment rate due to its complex booking flow, poor mobile
                optimization, and limited accessibility features. BIAT
                approached me to completely revamp the platform to offer a
                seamless experience for both customers and staff.
              </p>

              <div className="w-full justify-between items-center my-10 md:my-14">
                <h1 className="text-xl md:text-2xl font-extrabold my-4">
                  Role & Project
                </h1>
                <p className="text-base md:text-lg">
                  I led the redesign process, from initial research and
                  wireframes to final UI design and developer handoff. I worked
                  closely with stakeholders and the development team to ensure
                  the new platform met user needs and business goals.
                </p>
                <div className=" ">
                  {/* Before/After Comparison */}
                  <div className="mb-8">
                    <h1 className="text-xl md:text-2xl font-extrabold my-4">
                      Before/After Comparison
                    </h1>
                    <div className="mb-4">
                      <h3 className="text-lg font-semibold my-4">
                        Before the Redesign
                      </h3>
                      <ul className="list-disc text-base ">
                        <li>
                          6-step booking process, causing frustration for users.
                        </li>
                        <li>
                          No clear visual feedback during the booking process,
                          leading to confusion.
                        </li>
                        <li>
                          Limited accessibility, making it difficult for users
                          with disabilities to navigate.
                        </li>
                      </ul>
                    </div>

                    <div className="mb-4">
                      <h3 className="text-lg font-semibold my-4">
                        After the Redesign
                      </h3>
                      <ul className="list-disc text-base ">
                        <li>
                          Streamlined 4-step process, reducing user friction and
                          abandonment rates.
                        </li>
                        <li>
                          Introduced real-time feedback during the booking
                          process with time-slot selection and confirmation
                          pop-ups.
                        </li>
                        <li>
                          Enhanced accessibility with improved contrast, larger
                          fonts, and screen reader compatibility.
                        </li>
                      </ul>
                    </div>
                    <h1 className="text-xl md:text-2xl font-extrabold my-10">
                      Wireframes
                    </h1>

                    <div className="relative flex justify-center items-center w-full h-full">
                      {/* <div className="absolute top-0 w-full bg-black h-[4rem] z-50 "></div> */}
                      <iframe
                        className=" w-full px-[10%] md:px-[0%] md:w-full h-screen"
                        src="https://embed.figma.com/design/0WOt3g1PVdBdkaS4SfV3HV/Liberrex---monrdv-project-preview?node-id=0-1&embed-host=share"
                        allowfullscreen
                        title="work"
                      ></iframe>
                      <div className="absolute bottom-0 w-full bg-white h-[50px] z-50 "></div>
                    </div>
                  </div>

                  {/* Design Process */}
                  <div className="mb-8">
                    <h2 className="text-xl md:text-2xl font-extrabold my-4">
                      During the Design Process
                    </h2>
                    <div className="mb-4">
                      <h3 className="text-lg font-semibold my-4">
                        Improving the Workflow
                      </h3>
                      <p className="text-base mb-2">
                        I reduced redundant actions from 6 to 4, eliminating
                        confusion and streamlining the workflow based on user
                        interviews and journey mapping.
                      </p>
                    </div>

                    <div className="mb-4">
                      <h3 className="text-lg font-semibold my-4">
                        Contributing to the Design System
                      </h3>
                      <p className="text-base mb-2">
                        I introduced reusable components like modular buttons,
                        dropdowns, and icon sets, ensuring consistency across
                        the platform.
                      </p>
                    </div>

                    <div className="mb-4">
                      <h3 className="text-lg font-semibold my-4">
                        Testing and Insights
                      </h3>
                      <p className="text-base mb-2">
                        User testing revealed issues with time-slot selection,
                        which I redesigned using a more intuitive calendar-based
                        UI with real-time feedback.
                      </p>
                    </div>

                    <div className="mb-4">
                      <h3 className="text-lg font-semibold my-4">
                        Handoff to Developers
                      </h3>
                      <p className="text-base mb-2">
                        I used interactive Figma prototypes and created detailed
                        design documentation to ensure a smooth handoff to
                        developers.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {/* Visuals */}
            <div className="w-full h-full pb-10 px-[10%] md:px-[20%] bg-white text-neutral-600 ">
              <h1 className="text-xl md:text-2xl font-extrabold mb-4">
                Prototypes
              </h1>
            </div>

            <div className="relative w-full h-full mt-10">
              <div className="absolute bottom-1 w-full bg-black h-[50px] z-50 "></div>

              <iframe
                title="work"
                className="relative w-full h-[20rem] md:h-screen"
                src="https://embed.figma.com/proto/0WOt3g1PVdBdkaS4SfV3HV/Liberrex---monrdv-project-preview?node-id=267-18402&node-type=canvas&scaling=scale-down&content-scaling=fixed&page-id=0%3A1&starting-point-node-id=267%3A18402&show-proto-sidebar=1&embed-host=share"
                allowfullscreen
              ></iframe>
            </div>

            {/* After the Project */}
            <div className="w-full h-full py-20 px-[10%] md:px-[20%] bg-white text-neutral-600 ">
              <div className="mb-8">
                <h2 className="text-2xl font-semibold mb-4">
                  Impact & Results
                </h2>
                <div className="mb-4">
                  <h3 className="text-lg font-semibold my-4">
                    Stakeholder Feedback
                  </h3>
                  <blockquote className="border-l-4 border-blue-500 pl-4 italic text-base">
                    “This redesign has transformed how our customers interact
                    with our services. Appointment bookings have never been
                    easier, and our customer satisfaction scores have reflected
                    that.”
                  </blockquote>
                </div>

                <div className="mb-4">
                  <h3 className="text-lg font-semibold my-4">User Feedback</h3>
                  <blockquote className="border-l-4 border-green-500 pl-4 italic text-base">
                    “The new system is much faster and easier to use, especially
                    on mobile. I can book an appointment in just a few taps.”
                  </blockquote>
                </div>

                <div className="mb-4">
                  <h3 className="text-lg font-semibold my-4">
                    Quantitative Results
                  </h3>
                  <ul className="list-disc text-base">
                    <li>
                      Appointment booking time reduced by 30%, from 5 minutes to
                      3 minutes.
                    </li>
                    <li>Bounce rate decreased by 15%.</li>
                  </ul>
                </div>

                <div className="mb-4">
                  <h3 className="text-lg font-semibold my-4">
                    Accommodating Future Growth
                  </h3>
                  <p className="text-base">
                    The design is modular and scalable, allowing BIAT to easily
                    expand the platform with new services and features without
                    requiring a full redesign.
                  </p>
                </div>
              </div>

              {/* Final Thoughts */}
              <div className="mb-8">
                <h2 className="text-lg font-semibold mb-4">
                  Final Thoughts and Takeaways
                </h2>
                <p className="text-base mb-4">
                  This project was a great opportunity to tackle real user
                  challenges and create a product that not only improved the
                  lives of BIAT's customers but also provided tangible business
                  benefits. I prioritized the user experience while ensuring the
                  platform was scalable for future growth.
                </p>
                <p className="text-lg font-semibold my-4">Next Steps</p>
                <p className="text-base">
                  I look forward to refining the platform further as BIAT
                  continues to introduce more services.
                </p>
              </div>
              <div className="w-full text-center mx-auto mt-20 mb-10">
                <a
                  href="https://rdv.biat.com.tn/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className=" p-4 text-sm lg:text-base text-white font-medium bg-neutral-800 hover:bg-transparent hover:text-neutral-800 border-2 border-neutral-800"
                >
                  View final product
                </a>
              </div>
              <div className="w-full text-center mx-auto">
                <a
                  href="/works"
                  rel="noopener noreferrer"
                  className=" text-sm lg:text-base text-neutral-800 font-medium underline"
                >
                  Back to projects
                </a>
              </div>
            </div>
          </div>
        </>
      )}
      <div className=" bg-black flex flex-col md:flex-row justify-start items-center ">
        <img src={getStartedImage} alt="get started" className="w-[50%]" />
        <div className="w-full h-full gap-10 flex flex-col justify-center items-center md:items-start mx-auto pb-20 md:pb-0">
          <p className="text-3xl lg:text-5xl md:w-[90%] px-[10%] md:px-0 text-center md:text-start font-semibold">
            Want to build remarkable products together?
          </p>
          <a
            href="https://www.linkedin.com/in/nacermediouni/"
            aria-label="Linkedin"
            target="_blank"
            rel="noreferrer"
            className=" text-2xl lg:text-3xl text-[#00ffc6] font-bold underline underline-offset-2 hover:underline-offset-1"
          >
            Let's get strated!
          </a>
        </div>
      </div>

      <div className="  w-full flex flex-col justify-center items-center pt-20 pb-8 px-[10%] md:px-[20%] font-sans bg-white">
        <Footer />
      </div>
    </div>
  )
}

export default Biat
